import React from 'react';

interface DiceIconProps {
  className?: string;
  style?: React.CSSProperties;
  /** Rendered width/height in px. */
  size?: number;
}

/**
 * Dice icon in Fluent v9 Regular (outline) style.
 *
 * Used as the visual metaphor for randomization actions (e.g. the
 * student randomizer in the classbook). There is no equivalent dice/casino
 * glyph in `@fluentui/react-icons`, so this icon is provided as a custom
 * SVG to keep the visual language consistent with the rest of the app.
 *
 * The artwork shows the "5" face of a die: a rounded square outline with
 * five filled pips arranged in the standard pattern. The outer body is
 * stroked and the pips are filled, both with `currentColor`.
 */
export const DiceIcon: React.FC<DiceIconProps> = ({ className, style, size = 20 }) => (
  <svg
    role="presentation"
    focusable="false"
    aria-hidden="true"
    viewBox="0 0 20 20"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    className={className}
    style={style}
  >
    <rect
      x="3.25"
      y="3.25"
      width="13.5"
      height="13.5"
      rx="2.5"
      strokeWidth="1.5"
    />
    <g fill="currentColor" stroke="none">
      <circle cx="7" cy="6" r="1" />
      <circle cx="13" cy="6" r="1" />
      <circle cx="10" cy="10" r="1" />
      <circle cx="7" cy="14" r="1" />
      <circle cx="13" cy="14" r="1" />
    </g>
  </svg>
);
